<template>
    <section class="the-pillars" :style="vars">
        <div class="container">
            <h2 class="the-pillars__title" v-html="$c('pillars.title')"></h2>
            <p v-html="$c('pillars.content')" class="the-pillars__description">
            </p>
        </div>
        <div class="container">
            <div class="pillars-grid">
                <a class="pillar easyfix" :href="$c('pillar_1.url.content')">
                    <div class="pillar__logo-wrapper">
                        <img :src="`${PUBLIC_PATH}/img/logo-easyfix.png`">
                    </div>
                    <div class="pillar__description" v-html="$c('pillar_1.content')"></div>
                    <div class="normal-img-wrapper">
                        <img class="normal-img" :src="`${PUBLIC_PATH}/img/img-easyfix.png`">
                    </div>
                    <div class="background"></div>
                </a>
                <div class="line"></div>
                <a class="pillar bim" :href="$c('pillar_2.url.content')">
                    <div class="pillar__logo-wrapper">
                        <img :src="`${PUBLIC_PATH}/img/logo-bim.png`">
                    </div>
                    <div class="pillar__description" v-html="$c('pillar_2.content')"></div>
                    <div class="normal-img-wrapper">
                        <img class="normal-img" :src="`${PUBLIC_PATH}/img/img-bim.png`">
                    </div>
                    <div class="background"></div>
                </a>
                <div class="line"></div>
                <a class="pillar technical-helpdesk" :href="$c('pillar_3.url.content')">
                    <div class="pillar__logo-wrapper">
                        <img :src="`${PUBLIC_PATH}/img/logo-technical-helpdesk.png`">
                    </div>
                    <div class="pillar__description" v-html="$c('pillar_3.content')"></div>
                    <div class="normal-img-wrapper">
                        <img class="normal-img" style="max-width: 100%"
                             :src="`${PUBLIC_PATH}/img/img-technical-helpdesk.png`">
                    </div>
                    <div class="background"></div>
                </a>
                <div class="line"></div>
                <a class="pillar onsite" :href="$c('pillar_4.url.content')">
                    <div class="pillar__logo-wrapper">
                        <img :src="`${PUBLIC_PATH}/img/logo-onsite.png`">
                    </div>
                    <div class="pillar__description" v-html="$c('pillar_4.content')"></div>
                    <div class="normal-img-wrapper">
                        <img class="normal-img" :src="`${PUBLIC_PATH}/img/img-onsite.png`">
                    </div>
                    <div class="background"></div>
                </a>
                <div class="line"></div>
                <a class="pillar product-selector" :href="$c('pillar_5.url.content')">
                    <div class="pillar__logo-wrapper">
                        <img :src="`${PUBLIC_PATH}/img/logo-product-selector.png`">
                    </div>
                    <div class="pillar__description" v-html="$c('pillar_5.content')"></div>
                    <div class="normal-img-wrapper">
                        <img class="normal-img" :src="`${PUBLIC_PATH}/img/img-product-selector.png`">
                    </div>
                    <div class="background"></div>
                </a>
                <div class="line"></div>
                <a class="pillar technical-library" :href="$c('pillar_6.url.content')">
                    <div class="pillar__logo-wrapper">
                        <img :src="`${PUBLIC_PATH}/img/logo-technical-library.png`">
                    </div>
                    <div class="pillar__description" v-html="$c('pillar_6.content')"></div>
                    <div class="normal-img-wrapper">
                        <img class="normal-img" :src="`${PUBLIC_PATH}/img/img-technical-library.png`">
                    </div>
                    <div class="background"></div>
                </a>
                <div class="line"></div>
                <a class="pillar pos" :href="$c('pillar_7.url.content')">
                    <div class="pillar__logo-wrapper">
                        <img :src="`${PUBLIC_PATH}/img/logo-pos.png`">
                    </div>
                    <div class="pillar__description" v-html="$c('pillar_7.content')"></div>
                    <div class="normal-img-wrapper">
                        <img class="normal-img" :src="`${PUBLIC_PATH}/img/img-pos.png`">
                    </div>
                    <div class="background"></div>
                </a>
                <div class="line"></div>
            </div>
        </div>
    </section>
</template>

<script>
    const PUBLIC_PATH = process.env.VUE_APP_ASSETS_PATH;
    export default {
        data() {
            return {
                PUBLIC_PATH,
                vars: {
                    '--img-easyfix': `url('${PUBLIC_PATH}/img/img-easyfix.png')`,
                    '--img-bim': `url('${PUBLIC_PATH}/img/img-bim.png')`,
                    '--img-technical-helpdesk': `url('${PUBLIC_PATH}/img/img-technical-helpdesk.png')`,
                    '--img-technical-library': `url('${PUBLIC_PATH}/img/img-technical-library.png')`,
                    '--img-onsite': `url('${PUBLIC_PATH}/img/img-onsite.png')`,
                    '--img-product-selector': `url('${PUBLIC_PATH}/img/img-product-selector.png')`,
                    '--img-pos': `url('${PUBLIC_PATH}/img/img-pos.png')`,
                }
            }
        }
    }
</script>
